import api from 'api'

export const fetchSteps = async (formId) => {
  const { data } = await api.get(`/form/${formId}/step`)

  return data
}
